import React, { useMemo } from 'react';
import block from 'bem-cn';

import number1IMG from './img/number1.png';
import number2IMG from './img/number2.png';
import number3IMG from './img/number3.png';

import './Item.scss';

const b = block('statistic-table-row-desktop');

const Item = ({ item, type }) => {

  const icon = useMemo(() => {
    if (item.number === 1) return number1IMG;
    if (item.number === 2) return number2IMG;
    if (item.number === 3) return number3IMG;
    return '';
  }, [item.number]);

  const rowClass = b({ number: item.number, [type === 'players' ? 'six-columns' : 'four-columns']: true });

  return (
    <div className={rowClass}>
      <div className={b('td')}>
        {icon && (
          <div className={b('td-icon-wrap')}>
            <img className={b('td-icon')} src={icon} alt="" />
          </div>
        )}
        <span className={b('td-value')}>{item.number}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.id}</span>
      </div>
      <div className={b('td')}>
        <span className={b('td-value')}>{item.username}</span>
      </div>
      {type === 'players' && (
        <>
          <div className={b('td')}>
            <span className={b('td-value')}>{item.bets}</span>
          </div>
          <div className={b('td')}>
            <span className={b('td-value')}>{item.wins}</span>
          </div>
        </>
      )}
      <div className={b('td')}>
        <span className={b('td-value')}>{item.netwin}</span>
      </div>
    </div>
  );
};

export default Item;
